export function initMoreContent(): void {
	const triggers = document.querySelectorAll<HTMLButtonElement>('.js-more-btn');

	triggers.forEach((trigger) => {
		const targetId = trigger.getAttribute('aria-controls');

		if (!targetId) return;

		const target = document.getElementById(targetId);

		if (!target) return;

		trigger.addEventListener('click', () => {
			const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

			trigger.setAttribute('aria-expanded', String(!isExpanded));

			if (isExpanded) {
				target.hidden = true;
			} else {
				target.hidden = false;
			}
		});
	});
}
